<div class="sticky top-0 flex items-center justify-between bg-[#FCFDFE] pb-3">
  <h2 class="no-leading typo-h3-semibold">{{ titleTranslationKey() | translate }}</h2>
  @if (!isEaglesoftPms()) {
    <button
      class="btn-text gap-[0.625rem] text-[0.875rem]"
      (click)="onAddNewItem()"
      [disabled]="!addHealthHistoryEnabled()"
      [libUiTooltip]="!addHealthHistoryEnabled() ? addDisabledTooltip : undefined"
      tooltipPosition="bottom"
    >
      <svg-icon [ngClass]="addHealthHistoryEnabled() ? 'text-text-blue' : 'text-text-light'" key="px-24-plus"></svg-icon>
      {{ 'health_history_medical_alerts_add_new' | translate }}
    </button>

    <ng-template #addDisabledTooltip>
      <div class="typo-h7-light max-w-[190px] whitespace-pre-wrap p-1">
        {{ 'health_history_add_disabled_tooltip' | translate }}
      </div>
    </ng-template>
  }
</div>
<div class="flex flex-col gap-2">
  @for (item of healthHistoryItems(); track item.data.id) {
    <lib-health-history-item
      [healthHistoryItem]="item.data"
      [dropdownOptions]="item.dropdownOptions"
      [isEditMode]="item.isEditMode"
      [isNewItem]="item.isNewItem"
      [isLoading]="isLoading()"
      [editHealthHistoryEnabled]="editHealthHistoryEnabled()"
      [deleteHealthHistoryEnabled]="deleteHealthHistoryEnabled()"
      (changeEditMode)="setEditMode($event)"
      (deleteItem)="onDeleteItem($event)"
      (saveItem)="onSaveItem($event)"
      (discardNewItem)="onDiscardNewItem()"
    ></lib-health-history-item>
  } @empty {
    <span class="typo-h5-book text-text-tertiary">
      {{ emptyTextTranslationKey() | translate }}
    </span>
  }
</div>
